module.exports = __webpack_public_path__ + "static/media/body.cd87b833.svg";